import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterLocationSelected = createSelector(
    [
        (store: RootState) => store.formSubmittedSlice.selectedLocations,
        (store: RootState) => store.formSubmittedSlice.searchSelectedLocationText,
    ],
    (selectedLocations, searchText) => {
        const data = selectedLocations.filter(
            ({ name, code }) => {
                // Filtro por nombre 
                if (
                    searchText
                    && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
                    && !code?.toLowerCase().includes(searchText?.toLowerCase().trim())
                ) {
                    return false;
                }
                return true;
            }
        );
        // Ordena la lista alfabéticamente
        const orderedList = [...data].sort((a, b) => {
            if (a.name && b.name && a.name < b.name) {
                return -1;
            }
            if (a.name && b.name && a.name > b.name) {
                return 1;
            }
            return 0;
        });

        return orderedList;
    }
);
